import React, { Component } from 'react';

import { collectionNamesFromLabels } from '../utils/collectionsApi';

// Control "Novedad" + la línea de colecciones, compartido por la ficha de juego y la de
// accesorio (FormBoxGameComponent / FormAccessoryComponent).
//
// Vive en un componente propio y no duplicado en los dos forms porque las dos mitades tienen que
// moverse juntas: el `defaultValue` decide lo que se escribe en un alta, y `labels` es lo que se
// precarga y contra lo que se compara al guardar. Dos copias de esto se desincronizan la primera
// vez que alguien toque una sola.
//
// El `<select>` queda con `id="isNew"` y SIN estado de React a propósito: los dos forms leen su
// valor con `document.getElementById("isNew").value` al guardar y lo escriben igual al cargar la
// ficha. Convertirlo en un campo controlado acá obligaría a reescribir el guardado de los dos
// forms, que es un cambio bastante más grande que el que esta fase pide.
class NovedadFieldComponent extends Component {

    render() {
        // DEFAULT PRENDIDO AL ALTA. Lo pidió el dueño y recién ahora corresponde: hasta la fase
        // anterior este control escribía una columna que nadie leía, así que prenderlo por
        // defecto no habría hecho nada. Ahora escribe la membresía en el carrusel de la home, y
        // el criterio es que un producto nuevo ES una novedad salvo que digan lo contrario.
        //
        // En EDICIÓN arranca en "No" y `loadData` lo pisa con lo que diga la membresía apenas
        // vuelve el fetch. Arrancarlo en "Sí" también en edición mostraría "Novedad: Sí" por un
        // instante en productos que no lo son — y el `defaultValue` de React se aplica UNA vez,
        // al montar, así que la decisión se toma acá con el prop y no con el estado del fetch.
        const defaultValue = this.props.isEditing ? 'false' : 'true';
        const nombres = collectionNamesFromLabels(this.props.labels);

        return (
            <div className="form-group col-md-3">
                <label>Novedad</label>
                <select id="isNew" className="custom-select" defaultValue={defaultValue}>
                    <option value="true">Si</option>
                    <option value="false">No</option>
                </select>
                <small className="text-muted d-block">
                    Lo muestra en el carrusel "Novedades" del home.
                </small>
                {/* Única forma que tiene el operador de ver, desde la ficha, en qué secciones de
                    la home quedó este producto. Se muestra sólo en edición: en un alta todavía no
                    hay membresías y una línea que diga "ninguna" sería ruido. */}
                {this.props.isEditing && (
                    <small className="text-muted d-block mt-1">
                        Colecciones: {nombres.length > 0 ? nombres.join(', ') : 'ninguna'}
                    </small>
                )}
            </div>
        );
    }
}

export default NovedadFieldComponent;
